<template>
  <div class='orders'>

    <div class="float-right">
      <button-group 
        :p-button-group="computeLogLevelButtonGroup()"
        ></button-group>
    </div>
    <pager v-on:pagination="loadData" v-bind:items='this.order_logs || []'></pager>
    
    <div class="">
      <table class='table table-sm table-hover'>
        <thead class='thead-default'>
          <th>公司</th>
          <th>订单号</th>
          <th>用户</th>
          <th>时间</th>
          <th>内容</th>
        </thead>
        <tbody>
          <tr v-for='log of this.order_logs' :class="calculateRowColor(log)">
            <td>
              {{getCompanyDisplay(log.company_code)}}
            </td>
            <td>
              内部：<router-link :to="'/orders/' + log.order_no">{{log.order_no}}</router-link><br>
              外部：{{log.company_order_no}}<br>
           </td>
           <td>{{log.commander || ''}}</td>
           <td><local-time :time="log.created_at"></local-time></td>
           <td>{{log.message}}</td>
          </tr>
        </tbody> 
      </table>
    </div>
  </div>
</template>

<script>
import Pager from './_partial/Pager'
import LocalTime from '@/components/_small/LocalTime'
import InputMixin from '@/mixins/input'
import LoadDataMixin from '@/mixins/load_data'
import OrderMixin from '@/mixins/order'
import ButtonGroup from '@/components/_partial/ButtonGroup'

function loadData () {
  this.$http.doSpin()
  this.$http.get('/api/order_loggers' + location.search).then(response => {
    this.$http.cancelSpin()
    this.order_logs = response.data.data
  })
  .catch(function (error) {
    this.$http.cancelSpin()
    console.log(error)
  })
}

function calculateRowColor (log) {
  if (log.level === 'error') {
    return 'table-danger'
  }
  return ''
}

function computeLogLevelButtonGroup () {
  let levelGroup = {}
  levelGroup.name = '全部日志'
  levelGroup.value = ''
  levelGroup.key = 'level'
  levelGroup.display = {
    name: '全部日志',
    value: ''
  }

  levelGroup.menus = [{
    name: '全部日志',
    value: 'all'
  }, {
    name: '错误',
    value: 'error'
  }]
  return levelGroup
}

export default {
  name: 'order_loggers',
  mixins: [InputMixin, OrderMixin, LoadDataMixin],
  data () {
    return {
      order_logs: []
    }
  },
  mounted () {
    this.loadData()
  },
  components: {
    Pager,
    LocalTime,
    ButtonGroup
  },
  methods: {
    loadData,
    calculateRowColor,
    computeLogLevelButtonGroup
  }
}
</script>

<style lang='scss' scoped>
  .cart {
    position: fixed;
    width: 350px;
    right: 20px;
    bottom: 20px;
    overflow-y: auto;
    max-height: 80%;
    z-index: 1000;
  }
</style>